/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IGetUserMessage extends IMessage {
	id: string;
}

export default class GetUserMessage extends Message {
	public static readonly TYPE: string = '21';

	public static readonly READABLE_TYPE_NAME: string = 'getUser';

	public static readonly DESCRIPTOR_NAME: string = 'GetUserMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			id: {
				type: 'string',
				id: 1
			}
		}
	};

	public constructor( public readonly id: string ) {
		super();
	}

	public toJSON(): IGetUserMessage {
		return {
			id: this.id
		};
	}

	public static fromJSON( data: IGetUserMessage ): GetUserMessage {
		return new GetUserMessage( data.id );
	}
}
